/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H217483 on 1/17/2019.
 */

import React from 'react'
import {Loader as SLoader} from '@scuf/common';


class Loader extends React.Component {
    constructor(props) {
        super(props)

        this.defaultColor = '#F7F7F7'
        this.defaultOpacity = 0.5
    }

    render() {
        const color = this.props.color || this.defaultColor
        const opacity = this.props.opacity || this.defaultOpacity
        return (
            <SLoader loading={this.props.loading} overlayColor={color} overlayOpacity={opacity} {...this.props}/>
        )
    }
}


export default Loader